import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg24DownloadG = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey400,
      fillRule: "evenodd",
      d: "M20.661 16.3a.73.73 0 0 1 .73.71l.033 1.294-.001.023c0 .99-.811 1.795-1.807 1.795H4.129a1.804 1.804 0 0 1-1.805-1.725l-.003-.046v-.047l.033-1.293a.73.73 0 0 1 .73-.711c.36 0 .659.267.708.614l.007.097.006 1.264.002.039v.013c0 .177.144.32.322.32h15.487a.32.32 0 0 0 .322-.32v-.033l.002-.02.006-1.263a.715.715 0 0 1 .715-.711M11.958 4l.11.008c.361.054.638.366.637.741l-.013 8.9 4.362-4.363.083-.073a.748.748 0 0 1 .974 1.13l-5.64 5.642-.085.072a.75.75 0 0 1-.974-.072l-5.64-5.642-.073-.083a.75.75 0 0 1 .072-.974l.077-.067a.75.75 0 0 1 .98.067l4.368 4.366.013-8.905.007-.102A.75.75 0 0 1 11.958 4"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24DownloadG$1 = Svg24DownloadG;

export { Svg24DownloadG$1 as default };
